var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
        'uik-btn__disabled': _vm.disabled,
        'uik-btn__base': true,
        'uik-btn__success': _vm.success,
        'uik-btn__primary': _vm.primary,
        'uik-btn__empty': _vm.empty,
        'uik-btn__transparent': _vm.transparent,
        'uik-btn__error': _vm.error,
        'uik-btn__dark': _vm.dark,
        'uik-btn__clear': _vm.clear,
        'uik-btn__xs': _vm.xs,
        'uik-btn__lg': _vm.lg,
        'uik-btn__isExpanded': _vm.isExpanded,
        'uik-btn__isLoading': _vm.isLoading,
        'uik-btn__noBorder': _vm.borderless,
        'uik-btn__iconOnly': _vm.iconOnly,
        'uik-btn__rounded': _vm.rounded
    },attrs:{"title":_vm.iconOnly ? _vm.text:'',"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isLoading)?_c('div',{staticClass:"uik-btn__loading"},[_c('UikLoader',{attrs:{"color":_vm.loaderColor ? _vm.loaderColor:_vm.presetLoaderColor,"size":_vm.loaderSize,"type":_vm.loaderType}})],1):_vm._e(),_c('span',{staticClass:"uik-btn__content",class:{'uik-btn__content--reverse': _vm.iconPosition == 'right'}},[(_vm.icon)?_c('Uikon',{class:{'uikon--iconOnly': _vm.iconOnly}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),(_vm.text && !_vm.iconOnly)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }